import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';
import './DateTimePicker.css';
const filterPassedTime = time => {
  const currentDate = new Date();
  const selectedDate = new Date(time);

  return currentDate.getTime() < selectedDate.getTime();
};
let handleColor = time => {
  return time.getHours() > 8 ? 'text-green-1000' : 'text-red-100';
};
const DateAndTimePickers = ({
  startDate,
  setStartDate,
  showTimeSelect = false,
  timeIntervals = 30, // define time interval for time
  dateFormat = 'MMM d, yyyy', // for time Please use this 'MMM d, yyyy h:mm aa'
  minDate = false, // YYYY-MM-DD
  maxDate = false, // YYYY-MM-DD
  isPastDisabled = false,
  isFutureDisabled = false,
  filterTime = false,
  showMonthDropdown = false,
  showYearDropdown = false,
  placeholderText = 'Select date',
  lableText = '',
  inputStyle = { height: '43px' },
  labelStyle = {},
  showTimeSelectOnly = false, // make it true if you want only Time selector. you need to make true showTimeSelect also
  isClearable = false // clear button will appear to clear date.
}) => {
  isPastDisabled ? (minDate = new Date()) : '';
  isFutureDisabled ? (maxDate = new Date()) : '';
  minDate ? (minDate = moment(minDate).toDate()) : '';
  maxDate ? (maxDate = moment(maxDate).toDate()) : '';
  filterTime ? (filterTime = filterPassedTime) : '';
  const CustomInput = ({ onChange, placeholder, value, id, onClick }) => (
    <React.Fragment>
      <label className="text-black-400 mb-1" style={labelStyle}>
        {lableText}
      </label>
      <div className="w-full bg-white rounded border border-grey-350 hover:border-green-600 ">
        <input
          type="text"
          id="date"
          name="date"
          value={value}
          onClick={onClick}
          style={inputStyle}
          className="bg-white rounded-md font-normal font-roboto text-sm px-4"
          onChange={onChange}
          placeholder={placeholder}
          autocomplete="off"
        />
        <FontAwesomeIcon
          icon={faCalendarAlt}
          className="text-green-900 cursor-pointer mr-1 text-xl"
          onClick={onClick}
        />
      </div>
    </React.Fragment>
  );
  return (
    <DatePicker
      closeOnScroll={e => e.target === document}
      selected={startDate}
      onChange={date => setStartDate(date)}
      minDate={minDate}
      maxDate={maxDate}
      customInput={<CustomInput />}
      showTimeSelect={showTimeSelect}
      timeIntervals={timeIntervals}
      dateFormat={dateFormat}
      filterTime={filterTime}
      showMonthDropdown={showMonthDropdown}
      showYearDropdown={showYearDropdown}
      placeholderText={placeholderText}
      showTimeSelectOnly={showTimeSelectOnly}
      isClearable={isClearable}
      timeClassName={handleColor}
    />
  );
};
export default DateAndTimePickers;
